import colors from '@/design/colors';
import { HeadingSmall } from '@/design/typography';
import styled from 'styled-components';

export const Section = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  border-radius: 8px;
  border: 1px solid var(--Gray-100, #d9dbe3);
  background: var(--White, #fff);

  width: 100%;
`;

export const Header = styled.div`
  color: var(--Black-Alpha-200, #2f3139);
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  column-gap: 8px;

  button {
    margin-left: auto;
    margin-right: 0px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  width: 100%;
`;

export const HeaderIcon = styled.div`
  width: 18px;
  height: 18px;

  margin-right: 16px;
`;

export const TotalBadge = styled.span`
  ${HeadingSmall(14)};
  color: ${colors.white};

  border-radius: 30px;

  padding: 0 8px;

  background-color: ${colors.purple100};
`;
